import { faSpinnerThird } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const Loading = ({ size }) => {
	return <FontAwesomeIcon icon={faSpinnerThird} size={size || "sm"} spin />;
};

export default Loading;
